import { useNotificationStore } from "@/common/store/notificationStore";
import { useDeviceType } from "@/common/hooks";
import { deviceTypeEnum } from "@/common/utils/device";
import { Notification } from "./Notification";
import { clsx } from "clsx";

import "./Notification.scss";

export const NotificationList = () => {
  const items = useNotificationStore((s) => s.items);
  const isMobile = useDeviceType() === deviceTypeEnum.PHONE;
  const notificationSize = isMobile ? "mobile" : "desktop";

  if (items.length === 0) {
    return null;
  }

  const containerClass = clsx(
    "NotificationContainer",
    isMobile ? "NotificationContainer-mobile" : "NotificationContainer-desktop"
  );

  return (
    <div className={containerClass}>
      <div className="NotificationList">
        {items.map((item) => (
          <Notification key={item.id} size={notificationSize} {...item} />
        ))}
      </div>
    </div>
  );
};
